<template>
  <v-card class="white--text">
    <v-card-title class="title blue lighten-2">
      สติ๊กเกอร์จอดรถ
    </v-card-title>
    <v-card-text class="pa-1 blue lighten-1">
      <v-autocomplete
        :loading="loading"
        :items="academicYearItems"
        v-model="academicYear"
        item-value="id"
        item-text="yearSemester"
        label="ปี/ภาคการศึกษา"
        return-object
        hide-details
        outline
        dark
        @change="active = false"
      ></v-autocomplete>
      <v-progress-linear :indeterminate="true" background-color="blue lighten-1"
      color="blue lighten-3" v-if="academicYear && !active"></v-progress-linear>
    </v-card-text>

    <v-expand-transition>
    <div v-show="academicYear && active" align="center">
      <v-card-text>
        <data-table :academicYear="academicYear" :personItems="personItems" @active="active = $event"></data-table>
      </v-card-text>
    </div> 
    </v-expand-transition>
    
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DataTable from './dataTable.vue'

export default {
	components: {
    DataTable
  },
	data () {
		return {
      active: false,
      academicYear: null
		}
	},
  computed: {
    ...mapGetters({
      loading: 'academicYear/loadingStatus',
      academicYearItems: 'academicYear/academicYearItems',
      personItems: 'person/personItems'
    })
  },
	mounted () {
    this.fetchAcademicYears()
    this.fetchPersonItems()
  },
	methods: {
    ...mapActions({
      fetchAcademicYears: 'academicYear/fetchAcademicYears',
      fetchPersonItems: 'person/fetchPersonItems'
    })
	},
  watch: {

  }
}
</script>


// WEBPACK FOOTER //
// src/components/management/parking/index.vue